import React, { useState, useEffect } from 'react'
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router-dom';
import ReactFlagsSelect from 'react-flags-select';
import Countries from '../../assets/countries.json';
import Loader from 'react-loader-spinner';

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();


const SignupForm = ({ setUser, resendCode, product, setProduct, setPassword }) => {

    const [loading, setLoading] = useState(false);

    const [countries, setCountries] = useState([
        { countryCode: 'AU', country: 'Australia', phcode: '+61' },
        { countryCode: 'BH', country: 'Bahrain', phcode: '+973' },
        { countryCode: 'KW', country: 'Kuwait', phcode: '+965' },
        { countryCode: 'OM', country: 'Oman', phcode: '+968' },
        { countryCode: 'IQ', country: 'Iran', phcode: '+98' },
        { countryCode: 'QA', country: 'Qatar', phcode: '+974' },
        { countryCode: 'SA', country: 'Saudi Arabia', phcode: '+966' },
        { countryCode: 'AE', country: 'United Arab Emirates', phcode: '+971' }
    ]);

    const [customLabels] = useState(Countries);
    const [country, setCountry] = useState({});
    const [countryPhone, setCountryPhone] = useState({});
    const [checked, setChecked] = useState(false);
    const [submmitted, setSubmitted] = useState(false);
    const history = useHistory();
    let { p } = useParams();

    useEffect(() => {
        getCountries();
        if (loading === false) {
            getIP();
        }
        if (p === 'de') {
            setProduct('DriveExpert');
        }
    }, []);

    const getCountries = async () => {
        setLoading(true);

        try {
            const res = await axios.post('https://evalexpert.io/v1/getCountries')
            const data = res.data;

            if (data) {
                const countriesArr = data.map(country => ({ countryCode: country.iso, country: country.country, phcode: '+' + country.phonecode }));
                setCountries(countriesArr);
            }
            setLoading(false)

        } catch (error) {
            console.log('error', error);
            setLoading(false)

        }
    }

    const getIP = async () => {
        try {
            const res = await axios.get("https://ip-api.com/json")
            const data = res.data;
            if (data.country) {
                setCountryFromIP(data.country);
            } else {
                const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const countryFromTz = timeZone.split('/')[0];
                setCountryFromIP(countryFromTz);
            }
            setLoading(false)

        } catch (error) {
            console.log('error', error);
            setLoading(false);
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const countryFromTz = timeZone.split('/')[0];
            setCountryFromIP(countryFromTz);

        }
        
    }

    const setCountryFromIP = (countryFromIP) => {
        
        if (countryFromIP) {
            const countryArr = countries.map(country => {
                if (country.country === countryFromIP) {
                    country.selected = true;
                    setCountryPhone(country);
                    setCountry(country);
                    return country;
                }
                country.selected = false;
                return country;

            });
            setCountries(countryArr);
        }

    }

    // triggers when country / region changes
    const onCountryChangeCountry = (code) => {
        const countryArr = countries.map(country => {
            if (country.countryCode === code) {
                country.selected = true;
                // TODO: if hasn't been changed before
                setCountry(country);
                setCountryPhone(country);
                return country;
            }
            country.selected = false;
            return country;

        });
        setCountries(countryArr);

    }

    // triggers when country phone changes
    const onCountryChangePhone = (code) => {
        const countryArr = countries.map(country => {
            if (country.countryCode === code) {
                country.selected = true;
                setCountryPhone(country);
                return country;
            }
            country.selected = false;
            return country;

        });
        setCountries(countryArr);

    }

    return (
        <Formik
            initialValues={{
                name: '',
                email: '',
                phone: '',
                password: '',
                confirmPassword: ''
            }}
            validate={values => {
                
                const errors = {};
                if (!values.name) {
                    errors.name = 'Name is Required';
                } else if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/i.test(values.name)) {
                    errors.name = 'Name cannot contain special characters.';
                }
                if (!values.phone) {
                    errors.phone = 'Phone is Required';
                } else {
                    let phoneValid = false;
                    try {
                        phoneValid = phoneUtil.isValidNumberForRegion(phoneUtil.parse(country.phcode + '' + values.phone, country.countryCode), country.countryCode);
                    } catch (err) {
                        console.log(err);
                    }
                    if (!phoneValid) {
                        errors.phone = 'Phone is not valid';
                    }
                }
                if (!values.email) {
                    errors.email = 'Email is Required';
                } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                    errors.email = 'Invalid email address';
                }

                if (!values.password) {
                    errors.password = 'Password is Required';
                } else if (values.password.length < 6) {
                    errors.password = 'Password must be greater than 6 characters.';
                }
                if (values.password && values.confirmPassword && (values.password !== values.confirmPassword)) {
                    errors.password = 'Passwords do not match';
                }

                if (!checked && submmitted) {
                    errors.terms = 'Terms is Required';
                }
                return errors;

            }}
            onSubmit={async (values, { setSubmitting, setErrors }) => {

                setSubmitted(true);
                setSubmitting(true);

                values.phone = values.phone.replace(' ', '');

                const postData = { ...values, ...country, product: product, otp: 1 };
                const res = await axios.post('https://evalexpert.io/v1/register', postData);
                const data = res.data;

                if (data.success) {
                    if (data['2fa'].success === true) {
                        setUser(data.user);
                        setPassword(values.password);
                        history.push("/insightsdashboard/pages/dashboard/otp/email");
                    }
                } else if (data.error === "User Already Exists.") {
                    setErrors({email: 'Email Already Exists.'});
                }
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
            }) => (

                <form onSubmit={handleSubmit} className="space-y-4">
                    {loading && <div className="flex my-12">
                        <Loader
                            className="mx-auto opacity-70"
                            type="Rings"
                            color="#2879BE"
                            height={100}
                            width={100}
                        />
                    </div>}
                    {!loading &&
                        <>
                            <div>
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                    Full Name
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="name"
                                        name="name"
                                        type="name"
                                        placeholder="Full Name"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.name}
                                        autoComplete="name"
                                        className={
                                            errors.name && touched.name ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                                : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        }
                                    />
                                    <p className="text-sm text-red-600" id="email-error">
                                        {errors.name && touched.name && errors.name}
                                    </p>
                                </div>
                            </div>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Email address
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        placeholder="Email Address"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        className={
                                            errors.email && touched.email ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                                : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        }
                                    />
                                    <p className="text-sm text-red-600" id="email-error">
                                        {errors.email && touched.email && errors.email}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                    Password
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        autoComplete="password"
                                        placeholder="Password"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.password}
                                        className={
                                            errors.password && touched.confirmPassword ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                                : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        }
                                    />
                                    <p className="text-sm text-red-600" id="password-error">
                                        {errors.password && touched.confirmPassword && errors.password}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                    Confirm Password
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        type="password"
                                        autoComplete="confirmPassword"
                                        placeholder="Confirm Password"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.confirmPassword}
                                        className={
                                            errors.password && touched.confirmPassword ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                                : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        }
                                    />
                                    <p className="text-sm text-red-600" id="password-error">
                                        {errors.password && touched.confirmPassword && errors.password}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                                    Country / Region
                                </label>
                                <ReactFlagsSelect
                                    id="country"
                                    name="country"
                                    searchable
                                    selected={country.countryCode}
                                    onSelect={(code) => { onCountryChangeCountry(code) }}
                                    className={errors.country ? "block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md border-red-300 text-red-900 placeholder-red-300"
                                        : "block w-full py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    }
                                />
                                <p className="text-sm text-red-600" id="email-error">
                                    {errors.country && touched.country && errors.country}
                                </p>
                            </div>

                            <div>
                                <label htmlFor="phone-number" className="block text-sm font-medium text-gray-700">
                                    Phone Number
                                </label>
                                <div className="relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 inset-x-0 left-0 flex items-center" style={{ width: '100px' }}>
                                        <ReactFlagsSelect
                                            id="country"
                                            name="country"
                                            searchable
                                            selected={countryPhone.countryCode}
                                            onSelect={(code) => { onCountryChangePhone(code) }}
                                            customLabels={customLabels}
                                            placeholder="Phone Code"
                                            className="phoneFlag focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
                                            style={{ border: 'none !important' }}
                                        />
                                    </div>

                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className={
                                            errors.phone && touched.phone ? "focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-32 sm:text-sm border-gray-300 rounded-md focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                                : "focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-32 sm:text-sm border-gray-300 rounded-md"
                                        }
                                        placeholder="987 6543"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.phone}
                                    />
                                </div>
                                <p className="text-sm text-red-600" id="phone-error">
                                    {errors.phone && touched.phone && errors.phone}
                                </p>
                            </div>

                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <input
                                        id="terms"
                                        name="terms"
                                        type="checkbox"
                                        className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                        defaultChecked={checked}
                                        onChange={() => setChecked(!checked)}
                                    />
                                    <label htmlFor="terms" className={errors.terms ? "ml-2 block text-sm text-red-600" : "ml-2 block text-sm text-gray-900"}>
                                        I agree to <a target="_blank" href="https://www.evalexpert.com/evalexpert-terms-of-use">{product}'s Terms of Use</a>
                                    </label>
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Submitting" : "Sign Up"}
                                </button>
                            </div>
                            <p className="mt-2 text-sm text-gray-700">
                                Already an {product} User? <p className="cursor-pointer text-sm text-gray-800 inline font-medium" onClick={() => history.push('/insightsdashboard/pages/dashboard/signin')}>Sign In</p>
                            </p>
                        </>
                    }
                </form>
            )}
        </Formik>
    )
}

export default SignupForm
